export enum PredefinedFileActions {
  FILE_ACTION_DOWNLOAD = "FILE_ACTION_DOWNLOAD",
  FILE_ACTION_GENERATE_APP_RESOURCE = "FILE_ACTION_GENERATE_APP_RESOURCE"
}
